import XMLParser from "@nodable/flexible-xml-parser";
import { CompactBuilderFactory } from "@nodable/compact-builder";

function buildValueParsers(config) {
  const parsers = ["entity"];
  if (config.trimValues) parsers.push("trim");
  if (config.parseNumbers) parsers.push("number");
  if (config.parseBooleans) parsers.push("boolean");
  return parsers;
}

export function createXmlParser(config) {
  const valueParsers = buildValueParsers(config);
  const builder = new CompactBuilderFactory({
    tags: { valueParsers },
    attributes: { valueParsers },
  });

  const parserOptions = {
    OutputBuilder: builder,
    skip: {
      attributes: config.skipAttributes,
      declaration: config.skipDeclaration,
      comment: config.skipComment,
      nsPrefix: config.skipNsPrefix,
    },
    attributes: {
      prefix: config.attributePrefix || "@_",
    },
  };

  if (config.maxNestedTags) {
    parserOptions.limits = { maxNestedTags: config.maxNestedTags };
  }

  return new XMLParser(parserOptions);
}

export function parseXmlString(parser, xmlString) {
  const trimmed = (xmlString ?? "").trim();
  if (!trimmed) {
    throw new Error("Cell is empty.");
  }

  return parser.parse(trimmed);
}
